<xemex-dialog-shell [title]="'installationGroups.edit.title' | translate">
  <form [formGroup]="form" class="flex flex-col gap-4 p-2">
    <xemex-text-field
      formControlName="name"
      [label]="'installationGroups.create.name' | translate"
      [required]="true"
      [invalid]="form.controls['name'].invalid && form.controls['name'].touched"
      [errorText]="
        'error.required' | translate: { field: ('installationGroups.create.name' | translate) }
      "
    />

    <xemex-text-field
      formControlName="description"
      [label]="'installationGroups.create.description' | translate"
    />

    <xemex-select-field [label]="'installationGroups.table.status' | translate" [required]="true">
      <mat-select formControlName="status">
        @for (status of statuses; track status) {
          <mat-option [value]="status">
            {{ 'installationGroups.edit.statuses.' + status | translate }}
          </mat-option>
        }
      </mat-select>
    </xemex-select-field>
  </form>

  <mat-dialog-actions actions>
    <xemex-filled-button type="button" (click)="onSave()">
      {{ 'general.btnSave' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
